// extracted by mini-css-extract-plugin
module.exports = {"image":"image--SpacesLimit-paywalls-components__1WXMX","description":"description--SpacesLimit-paywalls-components__1qf43"};